var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<form class=\"dialog-confirmation\">\n    <div class=\"dialog-header bg-peter-river-90\">\n        <div class=\"icon bg-belize-hole\" style=\"font-size: 42px;\">\n            <i class=\"fa fa-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "\"></i>\n        </div>\n        <div class=\"header\">\n            "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "\n            <div class=\"subheader\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"subtitle") : depth0), depth0))
    + "</div>\n        </div>\n    </div>\n    <div class=\"dialog-body-upload\" style=\"padding: 15px;\">\n        <div class=\"entry\">\n            <div class=\"media\">\n                <div class=\"media-body message\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0))
    + "</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"dialog-actions\">\n        <div class=\"pull-left\">\n            <button type=\"reset\" class=\"confirmation-cancel\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Action.Cancel",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":61},"end":{"line":20,"column":85}}}))
    + "</button>\n        </div>\n        <div class=\"pull-right\">\n            <button type=\"submit\" class=\"confirmation-submit\">"
    + alias2(__default(require("./i18n.js")).call(alias3,"Action.Confirm",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":23,"column":62},"end":{"line":23,"column":87}}}))
    + "</button>\n        </div>\n    </div>\n</form>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/dialog-confirmation.hbs
// module id = YO2j
// module chunks = 1